module.exports = __webpack_public_path__ + "img/emma_drinking.a333059c.svg";